import f3tch from 'f3tch';

// Constants
import API_URL from '../../../api/constants/url.constant.api';

// Profiles
import profile from '../../../api/profiles/json.profile.api';

/**
 * Update a tyre's price data
 * @param {string} tyreId - The tyre _id
 * @param {object} data - The fields to update (grossPrice, netPrice, discountGrossPrice)
 */
const updateTyreApi = (tyreId, data = {}) =>
  f3tch(`/tyres/${tyreId}`)
    .profile(profile({ url: API_URL() }))
    .body(data)
    .patch();

export default updateTyreApi;

